module.exports = __webpack_public_path__ + "static/media/wavecom.c4b49df3.png";